
<div class="row row-cols-sm-auto mb-2">
    <form class="col-8 filter-margin">
        <div class="row">
            <div class="col-4">
                <bryntum-combo #searchDateOptionInput [autoExpand]="true" [items]="dateRangeFilterComboConfig.items"
                value [value]="dateRangeFilterComboConfig.value" [listeners]="dateRangeFilterComboConfig.listeners"
                [width]="dateRangeFilterComboConfig.width"></bryntum-combo>
            </div>
            <div class="col-8">
                <bryntum-date-range-field
                    #dateFilterInput
                    [value]="dateRangeConfig.value"
                    [format]="dateRangeConfig.format"
                    [autoExpand]="true"
                    [listeners]="dateRangeConfig.listeners"
                >
                </bryntum-date-range-field>
            </div>
        </div>
    </form>
    <button
        class="btn btn-secondary reset-button m-2"
        (click)="resetFilters()"
    >Reset</button>
</div>
